import React from 'react';
import classNames from 'classnames';
import { Icon } from 'ui';
import createCell from '../createCell';

function isAsc(props) {
  return props.sort === 'asc';
}

const HeaderCell = props => {
  const sortStyleNames = classNames('SortIcon', {
    'ml-8': true,
    'SortIcon--asc': isAsc(props),
  });
  const contentStyleNames = classNames(
    'Table-cellContent fd-r ai-c',
    props.contentClassName,
  );

  const sortDirection = props.sort === 'desc' ? 'Decending' : 'Acending';
  const sortLabel = props.sort ? `: Sort ${sortDirection}` : '';
  const ariaLabel = `${props.name}` + sortLabel;

  return (
    <div
      role="button"
      tabIndex="0"
      className={props.className}
      onClick={props.onClick}
      onKeyPress={props.onClick}
      aria-label={ariaLabel}
    >
      <div className={contentStyleNames}>
        <div>{props.children}</div>
        {props.sort && (
          <div className={sortStyleNames}>
            <Icon name="triangle_down" />
          </div>
        )}
      </div>
    </div>
  );
};

const ROLE = 'headerCell';
HeaderCell.role = ROLE;
export const isHeaderCell = el => el && el.type.role === ROLE;

export default createCell(HeaderCell);
